var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.596,
    height: 14.3,
    viewBox: "0 0 14.596 14.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(899.979 1698.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M12.277,29.3A8.139,8.139,0,0,1,9.7,28.886a.742.742,0,0,0-.735.176L7.729,30.117a10.485,10.485,0,0,1-4.759-4.58L4.2,24.3a.7.7,0,0,0,.181-.723A8.214,8.214,0,0,1,3.972,21a.725.725,0,0,0-.722-.723H.722A.725.725,0,0,0,0,21,12.276,12.276,0,0,0,12.277,33.272.723.723,0,0,0,13,32.55V30.023A.725.725,0,0,0,12.277,29.3Z",
    transform: "translate(-899.979 -1717.272)",
    fill: "#47c06a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10902",
    "data-name": "Path 10902",
    d: "M0,2.387,2.387,0",
    transform: "translate(-890.886 -1695.184)",
    fill: "none",
    stroke: "#47c06a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    "data-name": "Path 10903",
    d: "M0,2.387,2.387,0",
    transform: "translate(-891.54 -1696.112) rotate(135)",
    fill: "none",
    stroke: "#47c06a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10901",
    "data-name": "Path 10901",
    d: "M0,2.387,2.387,0",
    transform: "translate(-887.571 -1692.143) rotate(45)",
    fill: "none",
    stroke: "#47c06a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCalls);
export default __webpack_public_path__ + "static/media/incoming-calls.930c9e98afc93bc0e554c9ef1f10b315.svg";
export { ForwardRef as ReactComponent };